
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { empty as empty_1, filter, ofArray, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Table } from "../../Widgets/Table/Table.js";
import { empty, singleton, append, delay, toArray as toArray_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { InventoryKind } from "../../Shared/InventoryStates.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Table_customPropertyValueDtoColumnDefinitions } from "../../Widgets/CustomProperties.js";

export function ReportView(props) {
    let elems, TableRows, matchValue_4;
    const t = useTranslation()[0];
    const routePath = (entry) => {
        let matchValue;
        return toArray((matchValue = entry.ToolType, (matchValue.tag === 1) ? ofArray(["toolswithquantity", entry.Id]) : ((matchValue.tag === 2) ? ofArray(["sets", entry.Id]) : ((matchValue.tag === 3) ? ofArray(["consumables", entry.Id]) : ofArray(["tools", entry.Id])))));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems = [createElement(Table, (TableRows = toArray(props.Report), {
        ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("createdAt", "", t("general.created_at"), (row) => (new CellContent(8, [row.CreatedAt])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("toolType", "", t("general.tool_type"), (dto) => {
            let matchValue_1;
            return new CellContent(5, [(matchValue_1 = dto.ToolType, (matchValue_1.tag === 1) ? (new InventoryKind(2, [])) : ((matchValue_1.tag === 2) ? (new InventoryKind(1, [])) : ((matchValue_1.tag === 3) ? (new InventoryKind(3, [])) : (new InventoryKind(0, [])))))]);
        }, "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("qrCodeIds", "", t("general.qr_code"), (row_1) => (new CellContent(0, [row_1.QrCodeIds])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("displayName", "", t("general.tool"), (dto_1) => (new CellContent(3, [dto_1.DisplayName, () => {
            RouterModule_nav(ofArray(routePath(dto_1)), 1, 1);
        }])), "text", "button")), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (dto_2) => (new CellContent(3, [dto_2.Manufacturer, () => {
            RouterModule_nav(ofArray(routePath(dto_2)), 1, 1);
        }])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("tool.model"), (dto_3) => (new CellContent(3, [dto_3.Model, () => {
            RouterModule_nav(ofArray(routePath(dto_3)), 1, 1);
        }])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_2) => (new CellContent(0, [row_2.SerialNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_3) => (new CellContent(0, [row_3.InventoryNumber])), "text", "text")), delay(() => append((props.Customer.tag === 1) ? singleton(new ColumnDefinition$1("checkNumber", "", t("tool.prinzing.check_number"), (row_4) => (new CellContent(0, [row_4.Checknumber])), "text", "text")) : (empty()), delay(() => Table_customPropertyValueDtoColumnDefinitions(filter((propertyConfiguration) => {
            const matchValue_3 = propertyConfiguration.Visibility;
            switch (matchValue_3.tag) {
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 12:
                case 11:
                    return false;
                default:
                    return true;
            }
        }, props.PropertyConfigurations), t("tool.custom_properties"), (dto_4) => dto_4.CustomProperties, t))))))))))))))))))))),
        Controls: empty_1(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: (matchValue_4 = props.SelectedDuplicateCheckType, (matchValue_4 == null) ? ["createdAt", "asc"] : ((matchValue_4.tag === 1) ? ["serialNumber", "asc"] : ["inventoryNumber", "asc"])),
            Fullscreen: false,
            GlobalSearch: true,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

